import { render, staticRenderFns } from "./ReceiptSummary.vue?vue&type=template&id=70107294&scoped=true&"
import script from "./ReceiptSummary.vue?vue&type=script&lang=js&"
export * from "./ReceiptSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSummary.vue?vue&type=style&index=0&id=70107294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70107294",
  null
  
)

export default component.exports